import React, { ButtonHTMLAttributes } from 'react';
import { Icon, StyledButton, Wrapper } from './toggle.styled';
import { bottom, upper } from '../../assets/icons';

export type IProps = {
  open: boolean;
} & ButtonHTMLAttributes<any>;

export const Toggle = React.memo(({ open, ...props }: IProps) => {
  return (
    <StyledButton {...props}>
      <Wrapper>
        <Icon open={open} style={{ top: '0' }} src={bottom} />
        <Icon open={open} style={{ bottom: '12px' }} src={upper} />
      </Wrapper>
    </StyledButton>
  );
});
